import {useCallback, useRef} from "react"

export function useDebouncedCallbackForm(callback, delay = 700) {
  const timeoutRef = useRef(null)
  const lastArgsRef = useRef(null)

  const debouncedFn = useCallback((...args) => {
    lastArgsRef.current = args

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      callback(...lastArgsRef.current)
    }, delay)
  }, [callback, delay])

  const cancel = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
      timeoutRef.current = null
    }
  }

  return [debouncedFn, cancel]
}
